import React from "react"

export const Loading = () => (
  <div className="spinner__container">
    <div className="loading__spinner"></div>
  </div>
)
